<!-- StatusText 状态文字 -->
<template>
  <div class="status_text_main df ac jc cp">
    <div
      class="status_circle_box circle relative"
      :style="{
        background,
        width: size + 'px',
        height: size + 'px',
      }"
      :class="'bg-' + type"
    >
      <span class="absolute db circle"></span>
    </div>
    <div class="status_text_box fz-12 m-l-10">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusText",

  props: {
    // 大小
    size: {
      type: Number,
      default: 8,
    },
    // 模式
    type: {
      type: String,
      default: "primary",
    },
    // 背景色
    background: {
      type: String,
      default: "",
    },
    // 提示文字
    text: {
      type: String,
      default: "开启",
    },
  },
};
</script>

<style scoped lang="scss">
.status_circle_box > span {
  inset: 0;
  width: inherit;
  height: inherit;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-animation: animationStatusDot 1.2s ease-in-out infinite;
  animation: animationStatusDot 1.2s ease-in-out infinite;
}

.status_circle_box > span {
  background: inherit;
}

.status_text_box {
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

@keyframes animationStatusDot {
  0% {
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
    opacity: 0.6;
  }

  to {
    -webkit-transform: scale(2.4);
    transform: scale(2.4);
    opacity: 0;
  }
}

@-webkit-keyframes animationStatusDot {
  0% {
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
    opacity: 0.6;
  }

  to {
    -webkit-transform: scale(2.4);
    transform: scale(2.4);
    opacity: 0;
  }
}
</style>
